var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',{attrs:{"to":"dragable-modal"}},[_c('modal',{class:{ top50: _vm.topClass },attrs:{"clickToClose":false,"name":_vm.modalName,"height":_vm.height,"width":_vm.width,"draggable":_vm.draggable,"id":_vm.id}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }